import React, { useState } from "react";
import { useAuth } from "../../context/Auth";
import Tooltip from "react-tooltip-lite";
import strings from "../../utils/strings";
import axios from "axios";
import CryptoJS from "crypto-js";
import { baseURL } from "../../api";
import { shareLink } from "../../utils/utils";

export const Share = ({ id, content, image }) => {
  const { loginRedirectUrl } = useAuth();

  const [tooltip, setToolTip] = useState(strings.copyPost);

  const copyPostLinkToClipboard = () => {
    console.log("text", `${loginRedirectUrl}/post/${id}`);
    var textField = document.createElement("textarea");
    textField.innerText = `${loginRedirectUrl}/post/${id}`;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    setToolTip(strings.copiedPost);
  };


  // const encrypt = (str) => {
  //   if (!str) return '';
  //   return encodeURIComponent(CryptoJS.AES.encrypt(str, process.env.REACT_APP_SHARE_SECRET).toString());
  // };

  const premiumPost = content?.includes('{PremiumPicture}')

  return (
    <div className="ms-auto font-xssss v-center">
      Why not share? &nbsp;
      <a
        onClick={() => shareLink({ id, content })}
        href={`https://www.facebook.com/sharer/sharer.php?u=${baseURL}/api/v1/feed/share/${id}/${premiumPost ? '2' : '1'}`}
        target="_blank"
        className="mr-1 cursor-pointer"
      >
        <svg viewBox="0 0 64 64" width="32" height="32">
          <circle cx="32" cy="32" r="31" fill="#3b5998"></circle>
          <path
            d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
            fill="white"
          ></path>
        </svg>
      </a>
      {/* <a className="cursor-pointer">
        <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
          <defs>
            <linearGradient
              id="linear0"
              gradientUnits="userSpaceOnUse"
              x1="146.4465"
              y1="853.5535"
              x2="853.5535"
              y2="146.4465"
              gradientTransform="matrix(0.032,0,0,0.032,0,0)"
            >
              <stop
                offset={0}
                style={{
                  stopColor: "rgb(100%,83.529412%,12.941176%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.0551048"
                style={{
                  stopColor: "rgb(100%,81.568627%,12.54902%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.1241"
                style={{
                  stopColor: "rgb(99.607843%,75.294118%,11.764706%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.2004"
                style={{
                  stopColor: "rgb(98.823529%,65.490196%,10.588235%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.2821"
                style={{
                  stopColor: "rgb(98.039216%,51.372549%,8.627451%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.3681"
                style={{
                  stopColor: "rgb(97.254902%,33.333333%,6.27451%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.4563"
                style={{
                  stopColor: "rgb(96.078431%,11.764706%,3.529412%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.5"
                style={{
                  stopColor: "rgb(95.294118%,0%,1.960784%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.5035"
                style={{
                  stopColor: "rgb(94.901961%,0%,2.745098%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.5966"
                style={{
                  stopColor: "rgb(88.235294%,0%,23.137255%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.6879"
                style={{
                  stopColor: "rgb(82.745098%,0%,40.392157%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.7757"
                style={{
                  stopColor: "rgb(78.039216%,0%,53.333333%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.8589"
                style={{
                  stopColor: "rgb(74.901961%,0%,62.745098%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset="0.9357"
                style={{
                  stopColor: "rgb(73.333333%,0%,68.627451%)",
                  stopOpacity: 1,
                }}
              />
              <stop
                offset={1}
                style={{
                  stopColor: "rgb(72.54902%,0%,70.588235%)",
                  stopOpacity: 1,
                }}
              />
            </linearGradient>
          </defs>
          <g id="surface1">
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "url(#linear0)",
              }}
              d="M 16 32 C 7.164062 32 0 24.835938 0 16 C 0 7.164062 7.164062 0 16 0 C 24.835938 0 32 7.164062 32 16 C 32 24.835938 24.835938 32 16 32 Z M 16 32 "
            />
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "rgb(100%,100%,100%)",
                fillOpacity: 1,
              }}
              d="M 16 7.046875 C 18.914062 7.046875 19.261719 7.054688 20.414062 7.109375 C 21.476562 7.160156 22.058594 7.335938 22.441406 7.488281 C 22.949219 7.6875 23.316406 7.921875 23.695312 8.304688 C 24.078125 8.683594 24.3125 9.050781 24.511719 9.558594 C 24.664062 9.941406 24.839844 10.523438 24.890625 11.585938 C 24.941406 12.738281 24.953125 13.085938 24.953125 16 C 24.953125 18.914062 24.945312 19.261719 24.890625 20.414062 C 24.839844 21.476562 24.664062 22.058594 24.511719 22.441406 C 24.3125 22.949219 24.078125 23.316406 23.695312 23.695312 C 23.316406 24.078125 22.949219 24.3125 22.441406 24.511719 C 22.058594 24.664062 21.476562 24.839844 20.414062 24.890625 C 19.261719 24.941406 18.914062 24.953125 16 24.953125 C 13.085938 24.953125 12.738281 24.945312 11.585938 24.890625 C 10.523438 24.839844 9.941406 24.664062 9.558594 24.511719 C 9.050781 24.3125 8.683594 24.078125 8.304688 23.695312 C 7.921875 23.316406 7.6875 22.949219 7.488281 22.441406 C 7.335938 22.058594 7.160156 21.476562 7.109375 20.414062 C 7.058594 19.261719 7.046875 18.914062 7.046875 16 C 7.046875 13.085938 7.054688 12.738281 7.109375 11.585938 C 7.160156 10.523438 7.335938 9.941406 7.488281 9.558594 C 7.6875 9.050781 7.921875 8.683594 8.304688 8.304688 C 8.683594 7.921875 9.050781 7.6875 9.558594 7.488281 C 9.941406 7.335938 10.523438 7.160156 11.585938 7.109375 C 12.738281 7.054688 13.085938 7.046875 16 7.046875 M 16 5.078125 C 13.035156 5.078125 12.664062 5.089844 11.496094 5.144531 C 10.335938 5.199219 9.542969 5.382812 8.84375 5.65625 C 8.128906 5.929688 7.515625 6.304688 6.910156 6.910156 C 6.304688 7.519531 5.933594 8.128906 5.652344 8.847656 C 5.382812 9.542969 5.195312 10.335938 5.140625 11.5 C 5.089844 12.664062 5.074219 13.035156 5.074219 16.003906 C 5.074219 18.96875 5.089844 19.339844 5.140625 20.503906 C 5.195312 21.667969 5.378906 22.460938 5.652344 23.160156 C 5.929688 23.871094 6.304688 24.484375 6.910156 25.089844 C 7.519531 25.695312 8.128906 26.066406 8.847656 26.347656 C 9.542969 26.617188 10.335938 26.804688 11.5 26.859375 C 12.664062 26.910156 13.035156 26.925781 16.003906 26.925781 C 18.96875 26.925781 19.339844 26.910156 20.503906 26.859375 C 21.667969 26.804688 22.460938 26.621094 23.160156 26.347656 C 23.871094 26.070312 24.484375 25.695312 25.089844 25.089844 C 25.695312 24.480469 26.066406 23.871094 26.347656 23.152344 C 26.617188 22.457031 26.804688 21.664062 26.859375 20.5 C 26.910156 19.335938 26.925781 18.964844 26.925781 15.996094 C 26.925781 13.03125 26.910156 12.660156 26.859375 11.496094 C 26.804688 10.332031 26.621094 9.539062 26.347656 8.839844 C 26.070312 8.128906 25.695312 7.515625 25.089844 6.910156 C 24.480469 6.304688 23.871094 5.933594 23.152344 5.652344 C 22.457031 5.382812 21.664062 5.195312 20.5 5.140625 C 19.335938 5.089844 18.964844 5.078125 16 5.078125 Z M 16 5.078125 "
            />
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "rgb(100%,100%,100%)",
                fillOpacity: 1,
              }}
              d="M 16 10.390625 C 12.902344 10.390625 10.390625 12.902344 10.390625 16 C 10.390625 19.097656 12.902344 21.609375 16 21.609375 C 19.097656 21.609375 21.609375 19.097656 21.609375 16 C 21.609375 12.902344 19.097656 10.390625 16 10.390625 Z M 16 19.640625 C 13.992188 19.640625 12.359375 18.011719 12.359375 16 C 12.359375 13.988281 13.992188 12.359375 16 12.359375 C 18.007812 12.359375 19.640625 13.988281 19.640625 16 C 19.640625 18.011719 18.007812 19.640625 16 19.640625 Z M 16 19.640625 "
            />
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "rgb(100%,100%,100%)",
                fillOpacity: 1,
              }}
              d="M 23.140625 10.167969 C 23.140625 10.894531 22.554688 11.480469 21.832031 11.480469 C 21.105469 11.480469 20.519531 10.894531 20.519531 10.167969 C 20.519531 9.445312 21.105469 8.859375 21.832031 8.859375 C 22.554688 8.859375 23.140625 9.445312 23.140625 10.167969 Z M 23.140625 10.167969 "
            />
          </g>
        </svg>
      </a> */}
      <a
        onMouseLeave={() => setToolTip(strings.copyPost)}
        className="ml-1 cursor-pointer"
        onClick={copyPostLinkToClipboard}
      >
        <Tooltip className="my-tooltip small-size" content={tooltip}>
          <i class="fa-solid fa-link text-white me-2 btn-round-xs2 font-xss cursor-pointer hover-effect bg-cyan"></i>
        </Tooltip>
      </a>
      {/* <a class="d-flex align-items-center fw-600 text-grey-900 text-dark lh-26 font-xssss">
        <i class="feather-share-2 text-grey-900 text-dark btn-round-sm font-lg"></i>
        <span class="d-none-xs">Share</span>
      </a> */}
    </div>
  );
};
